import type { ElementType, FC } from "react";

interface StatCardProps {
  icon: ElementType;
  label: string;
  value: number | string;
  accent: string; // tailwind bg class e.g. "bg-brand-teal"
}

export const StatCard: FC<StatCardProps> = ({ icon: Icon, label, value, accent }) => (
  <div className="card p-5 flex items-center gap-4">
    <div className={`${accent} w-12 h-12 rounded-xl flex items-center justify-center shrink-0`}>
      <Icon size={22} className="text-white" />
    </div>
    <div className="min-w-0">
      <p className="text-brand-muted text-sm truncate">{label}</p>
      <p className="text-white text-2xl font-bold">{value}</p>
    </div>
  </div>
);

